/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited 2024.
 */

import { StoreLocatorBase } from '@/components/content/StoreLocator/StoreLocatorBase';
import { Order } from '@/data/types/Order';
import { FC } from 'react';

export const StoreLocatorCommon: FC<{ order?: Order }> = ({ order }) => {
	return (
		<StoreLocatorBase order={order} />
	);
};
